import { render, staticRenderFns } from "./DirectList.vue?vue&type=template&id=54afe907"
import script from "./DirectList.vue?vue&type=script&lang=js"
export * from "./DirectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports